var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 145C118.137 145 145 118.137 145 85C145 51.8629 118.137 25 85 25C51.8629 25 25 51.8629 25 85C25 118.137 51.8629 145 85 145Z",
    fill: "#8BF2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9555 119.412L46.6455 112.13L57.2374 88.9602L63.1954 96.2422L67.8294 111.468V120.074L51.9415 128.68L49.9555 119.412Z",
    fill: "#17E5A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 112.5L35.3916 134.638L34.5 137L36.0536 137.286L51.2795 129.342L50.6175 119.412L46 112.5Z",
    fill: "#4B27E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1813 71.7484L57.2373 88.9602L61.8713 94.2562L67.1672 108.82L67.8292 121.398L83.0551 112.13V100.876L82.3931 93.5942L78.4212 88.2982L68.4912 76.3823L65.1813 71.7484Z",
    fill: "#4B27E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7174 103.524L81.7314 93.5943L90.3374 98.2282L100.929 103.524L83.0554 112.792L83.7174 103.524Z",
    fill: "#17E5A0",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7831 138.053C34.1473 138.384 33.4536 137.72 33.7569 137.07L65.4157 69.2583L101.152 103.47L34.7831 138.053Z",
    stroke: "black",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5204 90.2976C74.301 85.3008 70.2194 80.1747 67.8272 75.955C66.6271 73.8379 65.8889 72.0129 65.6143 70.5867C65.3321 69.1215 65.5855 68.3695 65.9249 68.0149C66.2644 67.6604 67.0046 67.3744 68.4808 67.5925C69.9175 67.8048 71.773 68.4628 73.9403 69.5696C78.2602 71.7757 83.5593 75.6302 88.7786 80.627C93.998 85.6237 98.0796 90.7499 100.472 94.9696C101.672 97.0866 102.41 98.9117 102.685 100.338C102.967 101.803 102.713 102.555 102.374 102.91C102.035 103.264 101.294 103.55 99.8182 103.332C98.3815 103.12 96.526 102.462 94.3587 101.355C90.0388 99.1489 84.7397 95.2944 79.5204 90.2976Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9834 111.468V111.468C49.8032 116.137 51.6469 122.114 51.1208 128.123L51.0002 129.5",
    stroke: "black",
    strokeWidth: 2.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1677 121.398L67.3458 119.617C68.4922 108.153 64.5237 96.7675 56.5 88.5V88.5",
    stroke: "black",
    strokeWidth: 2.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0552 112.792V112.792C84.3529 106.551 83.865 100.07 81.6475 94.0928L80.5 91",
    stroke: "black",
    strokeWidth: 2.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4842 50.5639L92.8286 57.3864C92.2722 63.1765 90.0446 68.6799 86.4168 73.2269L81.0695 79.929",
    stroke: "#17E5A0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.159 49.2399L91.5034 56.0624C90.947 61.8525 88.7194 67.3559 85.0916 71.9028L79.7443 78.605",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4996 92.621L96.8796 89.5724C101.633 85.2856 107.632 82.6313 114.001 81.9973L120.065 81.3937",
    stroke: "#17E5A0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1753 91.1574L95.5554 88.1088C100.308 83.822 106.308 81.1677 112.677 80.5337L118.741 79.9301",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1113,
    cy: 44.606,
    r: 4.70796,
    stroke: "white",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.7871,
    cy: 43.282,
    r: 4.70796,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.719,
    cy: 69.7618,
    r: 4.70796,
    stroke: "white",
    strokeWidth: 2.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.394,
    cy: 68.4378,
    r: 4.70796,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.719,
    cy: 69.7618,
    r: 4.70796,
    stroke: "white",
    strokeWidth: 2.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.394,
    cy: 68.4378,
    r: 4.70796,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.282,
    cy: 109.282,
    r: 4.70796,
    stroke: "white",
    strokeWidth: 2.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.958,
    cy: 107.958,
    r: 4.70796,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.506,
    cy: 43.282,
    r: 4.70796,
    stroke: "white",
    strokeWidth: 2.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.183,
    cy: 41.958,
    r: 4.70796,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.6745,
    cy: 37.986,
    r: 1.98599,
    fill: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.915,
    cy: 57.8458,
    r: 1.98599,
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.718,
    cy: 56.5219,
    r: 1.98599,
    fill: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.155,
    cy: 90.9456,
    r: 1.98599,
    fill: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.07,
    cy: 101.538,
    r: 1.98599,
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.03 84.9877V92.9316",
    stroke: "#4B27E0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.059 88.9597H138.003",
    stroke: "#4B27E0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.705 83.6637V91.6076",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.733 87.6357H136.677",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.196 65.1278V73.0718",
    stroke: "#4B27E0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.225 69.0997H114.169",
    stroke: "#4B27E0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.872 63.8038V71.7477",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 67.7758H112.844",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5312 50.5639V58.5078",
    stroke: "#4B27E0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5596 54.5359H66.5035",
    stroke: "#4B27E0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.208 49.2399V57.1839",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2363 53.2119H65.1803",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.136bf955.svg";
export { ForwardRef as ReactComponent };